import React from "react";
import Card from "@mui/material/Card";
import useSales from "./useSales";
import {NavLink} from "react-router-dom";
import MDBox from "../../../../../components/MDBox";
import DataTable from "../../../../../components/DataTable/DataTable";
import {API_URL, COLOR_SECONDARY} from "../../../../../config";

const Sales = ({id}) => {
    const {actions } = useSales();

    return (
            <MDBox mt={2} sx={{padding: 2, borderStyle: 'solid', borderWidth: 1, borderColor: '#e2e2e2', borderRadius: 2}}>
                <MDBox mb={3}>
                        <DataTable
                            endpoint={`${API_URL}/sales/payout/${id}`}
                            title="Ventas"
                            description="Ventas asociadas al pago."
                            sortBy="id"
                            sortDirection="asc"
                            filter={false}
                            actions={actions}
                            colData={[
                                {
                                    name: 'id',
                                    label: 'Folio',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <NavLink to={`/ventas/${tableMeta.rowData[0]}`}
                                                     key={`venta-${tableMeta.rowData[0]}`}
                                                     style={{fontWeight: 500, color: COLOR_SECONDARY, textDecoration: 'underline'}}
                                            >
                                                #ORD-{value}
                                            </NavLink>
                                        )
                                    }
                                },
                                {
                                    name: 'patient.name',
                                    label: 'Paciente',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <div>
                                                {value} {tableMeta.rowData[2]} {tableMeta.rowData[3]}
                                            </div>
                                        )
                                    }
                                },
                                {
                                    name: 'patient.last_name',
                                    label: 'Apellido',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'patient.mother_last_name',
                                    label: 'Apellido Materno',
                                    options: {
                                        display: 'excluded'
                                    }
                                },
                                {
                                    name: 'location.display_name',
                                    label: 'Sucursal'
                                },
                                {
                                    name: 'doctor_fee',
                                    label: 'Comisión',
                                    options: {
                                        customBodyRender: (value, tableMeta, updateValue) => (
                                            <span>${value}</span>)
                                    }
                                },
                                {
                                    name: 'created_at',
                                    label: 'Fecha'
                                },
                            ]}
                        />
                </MDBox>
            </MDBox>
    );
};

export default Sales;
